import React from 'react'
import SelectBox from 'containers/LoanApplication/components/commons/SelectBox'

class RepaymentFrequency extends React.Component {
  onChange = (value) => {
    this.props.onChange(value)
  }

  render() {
    const {
      checked,
    } = this.props;

    return(
      <div>
        <div className="form-group mb-0">
          <label>How frequently do you want to repay?</label>
        </div>

        <div className='row no-gutters mb-3'>
          <div className='col-12 col-sm-4 mr-2'>
            <SelectBox
              checked={ checked == 'monthly'}
              value='monthly'
              text='Monthly'
              onChange={ this.onChange }
            />
          </div>
          <div className='col-12 col-sm-4 mr-2'>
            <SelectBox
              checked={ checked == 'fortnightly'}
              value='fortnightly'
              text='Fortnightly'
              onChange={ this.onChange }
            />
          </div>
        </div>
      </div>
    )
  }
}

export default RepaymentFrequency;
